var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.info.error)?_c('Error'):(_vm.$route.meta.layout)?_c(_vm.$route.meta.layout,{tag:"component"},[_c('router-view')],1):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }